/* Sepette kupon kodu uygulama.
   Shopify'da indirim kodu normalde sadece kasada girilir; sepette uygulamanın
   resmî yolu /discount/KOD uç noktasıdır — kodu oturuma işler, hem sepette hem
   kasada geçerli olur.

   Geçersiz kod sessizce yok sayılır (Shopify hata döndürmez), bu yüzden denenen
   kodu sessionStorage'a yazıp sayfa dönünce uygulanan kodlarla karşılaştırıyoruz;
   listede yoksa kullanıcıya uyarı gösteriyoruz. */
(function () {
  if (window.__ethosDiscount) return;
  window.__ethosDiscount = true;

  var ANAHTAR = 'ethosDiscountTry';

  function normalize(s) {
    return (s || '').trim().toUpperCase();
  }

  class EthosDiscount extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.ethos-discount__input');
      this.btn = this.querySelector('.ethos-discount__btn');
      this.msg = this.querySelector('[data-error]');
      if (!this.input || !this.btn) return;

      this.btn.addEventListener('click', () => this.uygula());
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.uygula();
        }
      });
      this.input.addEventListener('input', () => this.hataGizle());

      this.denemeyiKontrolEt();
    }

    get uygulananlar() {
      return (this.dataset.applied || '')
        .split('||')
        .map(normalize)
        .filter(Boolean);
    }

    uygula() {
      var kod = normalize(this.input.value);
      if (!kod) {
        this.input.focus();
        return;
      }
      try {
        sessionStorage.setItem(ANAHTAR, kod);
      } catch (e) {
        /* gizli sekme vs. — uyarı gösteremeyiz, uygulama yine de çalışır */
      }
      this.btn.setAttribute('disabled', '');
      window.location.href =
        '/discount/' + encodeURIComponent(kod) + '?redirect=' + encodeURIComponent(window.location.pathname);
    }

    /* Sayfa geri döndüğünde: denenen kod uygulananlar arasında yoksa uyar. */
    denemeyiKontrolEt() {
      var denenen;
      try {
        denenen = sessionStorage.getItem(ANAHTAR);
      } catch (e) {
        return;
      }
      if (!denenen) return;
      try {
        sessionStorage.removeItem(ANAHTAR);
      } catch (e) {}

      if (this.uygulananlar.indexOf(denenen) === -1) {
        this.hataGoster();
        this.input.value = denenen;
      }
    }

    hataGoster() {
      if (this.msg) this.msg.hidden = false;
      this.classList.add('ethos-discount--hata');
    }

    hataGizle() {
      if (this.msg) this.msg.hidden = true;
      this.classList.remove('ethos-discount--hata');
    }
  }

  if (!customElements.get('ethos-discount')) {
    customElements.define('ethos-discount', EthosDiscount);
  }
})();
